var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFontSizeArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow_down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M7.23174 10.0781C7.63153 10.5579 8.36839 10.5579 8.76818 10.0781L11.6332 6.64019C12.1759 5.98886 11.7128 5 10.8649 5H5.13503C4.28719 5 3.82404 5.98885 4.36681 6.64018L7.23174 10.0781Z",
    fill: "var(--fill-0, #585858)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontSizeArrowDown);
export default __webpack_public_path__ + "static/media/font-size-arrow-down.4888af11d0f1fbd954db52d493f65ab7.svg";
export { ForwardRef as ReactComponent };